import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ImmobilierService } from '../services/immobilier.service';
import { ExcelService } from '../excel.service';
import { PdfService } from '../services/pdf.service';


export interface AuditLog {
    id: number;
    user_id: number;
    user_name: string;
    action: string;
    entity_type: string;
    entity_id: number;
    details: string;
    ip_address: string;
    created_at: string;
}

@Component({
    selector: 'app-audit',
    templateUrl: './audit.component.html',
    styleUrls: ['./audit.component.css']
})
export class AuditComponent implements OnInit {

    displayedColumns: string[] = ['date', 'user', 'action', 'entity', 'details', 'ip'];
    dataSource: MatTableDataSource<AuditLog>;
    logs: AuditLog[] = [];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    // Filters
    // Filters
    filterUser: string = '';
    filterAction: string = '';
    filterEntity: string = '';


    // Pagination
    pageSize = 10;
    currentPage = 0;


    constructor(
        private immobilierService: ImmobilierService,
        private excelService: ExcelService,
        private pdfService: PdfService
    ) {
        this.dataSource = new MatTableDataSource(this.logs);
    }


    ngOnInit(): void {
        this.loadLogs();
    }

    loadLogs() {
        this.immobilierService.getAuditLogs().subscribe({
            next: (data) => {
                this.logs = data;
                this.dataSource.data = this.logs;
                if (this.paginator) {
                    this.dataSource.paginator = this.paginator;
                }
                if (this.sort) {
                    this.dataSource.sort = this.sort;
                }
            },
            error: (err) => {
                console.error(err);
            }
        });
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    onPageChange(event: any): void {
        this.pageSize = event.pageSize;
        this.currentPage = event.pageIndex;
    }


    getActionColor(action: string): string {
        switch (action) {
            case 'CREATE': return 'green';
            case 'UPDATE': return 'orange';
            case 'DELETE': return 'red';
            case 'LOGIN': return 'blue';
            default: return 'black';
        }
    }

    exportToExcel(): void {
        const dataToExport = this.dataSource.filteredData.map(l => ({
            'Date': l.created_at,
            'Utilisateur': l.user_name,
            'Action': l.action,
            'Entité': l.entity_type,
            'ID Entité': l.entity_id,
            'Détails': l.details,
            'IP': l.ip_address
        }));
        this.excelService.generateExcel(dataToExport, 'Journal_Audit');
    }

    exportToPdf(): void {
        this.pdfService.generatePdf('audit-table-container', 'Journal_Audit');
    }

    printPage(): void {
        window.print();
    }
}

